import { TypedSopNode } from "./_Base";
import { MergeSopOperation } from "../../operations/sop/Merge";
const INPUT_NAME = "geometry to merge";
import { NodeParamsConfig, ParamConfig } from "../utils/params/ParamsConfig";
import { NodeEvent } from "../../poly/NodeEvent";
const DEFAULT = MergeSopOperation.DEFAULT_PARAMS;
const DEFAULT_INPUTS_COUNT = 4;
class MergeSopParamsConfig extends NodeParamsConfig {
  constructor() {
    super(...arguments);
    this.compact = ParamConfig.BOOLEAN(DEFAULT.compact);
    this.inputsCount = ParamConfig.INTEGER(DEFAULT_INPUTS_COUNT, {
      range: [1, 32],
      rangeLocked: [true, false],
      callback: (node) => {
        MergeSopNode.PARAM_CALLBACK_setInputsCount(node);
      }
    });
  }
}
const ParamsConfig = new MergeSopParamsConfig();
export class MergeSopNode extends TypedSopNode {
  constructor() {
    super(...arguments);
    this.paramsConfig = ParamsConfig;
  }
  static type() {
    return "merge";
  }
  static displayedInputNames() {
    return [INPUT_NAME, INPUT_NAME, INPUT_NAME, INPUT_NAME];
  }
  setCompactMode(compact) {
    this.p.compact.set(compact);
  }
  initializeNode() {
    this.io.inputs.setCount(1, DEFAULT_INPUTS_COUNT);
    this.io.inputs.initInputsClonedState(MergeSopOperation.INPUT_CLONED_STATE);
    this.scene().dispatchController.onAddListener(() => {
      this.params.addOnSceneLoadHook("update inputs", () => {
        this._callbackUpdateInputsCount();
      });
    });
  }
  cook(inputCoreGroups) {
    this._operation = this._operation || new MergeSopOperation(this.scene(), this.states);
    const core_group = this._operation.cook(inputCoreGroups, this.pv);
    this.setCoreGroup(core_group);
  }
  _callbackUpdateInputsCount() {
    this.io.inputs.setCount(1, this.pv.inputsCount);
    this.emit(NodeEvent.INPUTS_UPDATED);
  }
  static PARAM_CALLBACK_setInputsCount(node) {
    node._callbackUpdateInputsCount();
  }
}
